import React, { createContext, useReducer, useContext, ReactNode } from 'react';

import { UserInfo } from '@verantos-dev/data-access-users';

enum DialogActionType {
  OPEN_DIALOG = 'OPEN_DIALOG',
  CLOSE_DIALOG = 'CLOSE_DIALOG',
}

type DialogType = 'createUser' | 'editUser' | 'displayUserInfo' | 'resetPassword' | null;

type UsersListDialogState = {
  activeDialog: DialogType;
  data: UserInfo | null;
};

type UsersListDialogAction =
  | { type: DialogActionType.OPEN_DIALOG; payload: DialogType; data?: UserInfo }
  | { type: DialogActionType.CLOSE_DIALOG };

const initialState: UsersListDialogState = {
  activeDialog: null,
  data: null,
};

const UsersListDialogContext = createContext<{
  state: UsersListDialogState;
  dispatch: React.Dispatch<UsersListDialogAction>;
}>({
  state: initialState,
  dispatch: () => null,
});

const dialogReducer = (
  state: UsersListDialogState,
  action: UsersListDialogAction
): UsersListDialogState => {
  switch (action.type) {
    case DialogActionType.OPEN_DIALOG:
      return { ...state, activeDialog: action.payload, data: action.data ?? null };
    case DialogActionType.CLOSE_DIALOG:
      return { ...state, activeDialog: null, data: null };
    default:
      return state;
  }
};

export const UsersListDialogProvider = ({ children }: { children: ReactNode }) => {
  const [state, dispatch] = useReducer(dialogReducer, initialState);

  return (
    <UsersListDialogContext.Provider value={{ state, dispatch }}>
      {children}
    </UsersListDialogContext.Provider>
  );
};

export const useUsersListDialogContext = () => useContext(UsersListDialogContext);
export { DialogActionType, DialogType };
